import React, {createContext, useContext, useMemo, useState} from 'react';

const dict = {
  ko: {
    title: 'Analytics 대시보드',
    subtitle: '실시간 데이터 분석 및 통계',
    logout: '로그아웃',
    logoutSuccess: '로그아웃되었습니다.',
    range: '기간 선택',
    today: '오늘',
    widgetDate: '위젯 일자',
    prevDay: '이전 날짜',
    nextDay: '다음 날짜',
    userStats: '유저 지표',
    revenueStats: '매출 지표',
    dau: 'DAU',
    dnu: '신규 유저',
    mau: 'MAU',
    pu: '결제 유저',
    revenue: '매출',
    arpu: 'ARPU',
    arppu: 'ARPPU',
    peopleUnit: '명',
    usdUnit: 'USD',
    chart: '추이',
    average: '기간 평균',
    total: '기간 총합',
    monthTotal: '월 총합',
    monthAverage: '월 평균',
    language: '언어',
    country: '국가',
    country_all: '전체',
    country_JP: '일본',
    country_KR: '한국',
    country_US: '미국',
    country_TH: '태국',
    country_TW: '대만',
    country_CN: '중국',
    country_HK: '홍콩',
    country_ETC: 'ETC',
    // Auth
    needAuth: '인증이 필요합니다.',
    login_title: 'Analytics 로그인',
    login_subtitle: '아이디와 패스워드를 입력해주세요',
    id_label: '아이디',
    id_placeholder: '아이디',
    password_label: '패스워드',
    password_placeholder: '패스워드',
    login_button: '로그인',
    error_required: '아이디와 패스워드를 입력해주세요.',
    login_success: '로그인되었습니다.',
    login_error_generic: '로그인 중 오류가 발생했습니다.',
  },
  ja: {
    title: 'アナリティクス ダッシュボード',
    subtitle: 'リアルタイム データ分析と統計',
    logout: 'ログアウト',
    logoutSuccess: 'ログアウトしました。',
    range: '期間選択',
    today: '今日',
    widgetDate: 'ウィジェット日付',
    prevDay: '前日へ',
    nextDay: '翌日へ',
    userStats: 'ユーザー指標',
    revenueStats: '売上指標',
    dau: 'DAU',
    dnu: '新規ユーザー',
    mau: 'MAU',
    pu: '課金ユーザー',
    revenue: '売上',
    arpu: 'ARPU',
    arppu: 'ARPPU',
    peopleUnit: '名',
    usdUnit: 'USD',
    chart: '推移',
    average: '期間平均',
    total: '期間合計',
    monthTotal: '月合計',
    monthAverage: '月平均',
    language: '言語',
    country: '国',
    country_all: '全体',
    country_JP: '日本',
    country_KR: '韓国',
    country_US: '米国',
    country_TH: 'タイ',
    country_TW: '台湾',
    country_CN: '中国',
    country_HK: '香港',
    country_ETC: 'その他',
    // Auth
    needAuth: '認証が必要です。',
    login_title: 'アナリティクス ログイン',
    login_subtitle: 'IDとパスワードを入力してください',
    id_label: 'ID',
    id_placeholder: 'ID',
    password_label: 'パスワード',
    password_placeholder: 'パスワード',
    login_button: 'ログイン',
    error_required: 'ID とパスワードを入力してください。',
    login_success: 'ログインしました。',
    login_error_generic: 'ログイン中にエラーが発生しました。',
  }
};

const I18nContext = createContext({ t: (k) => k, lang: 'ko', setLang: () => {} });

export const AnalyticsI18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('analytics_lang') || 'ko');
  const t = useMemo(() => (key) => dict[lang][key] || key, [lang]);
  const value = useMemo(() => ({ t, lang, setLang: (l) => { localStorage.setItem('analytics_lang', l); return setLang(l); } }), [t, lang]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);

export const getLocale = (lang) => (lang === 'ja' ? 'ja-JP' : 'ko-KR');
